import React, { useEffect, useState } from "react";
import OurLayouts from "../layout";
import surgeryicon from "../../assets/surgeryinewcon.svg";
import { Modal, Pagination } from "antd";
import axios from "axios";
import { format } from "date-fns";
import nodata from "../../assets/nodata.svg";
import { toast } from "react-toastify";
import customericon from "../../assets/Customer.svg";
import TrackEnquiry from "./TrackEnquiry";
import OrderDetailsModal, {
  SurgeryEnquiryCards,
} from "../shared/OrderDetailsModal";

const ClinicSurgeryDetails = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isModalVisible2, setIsModalVisible2] = useState(false);
  const [ticketdata, setTicketdata] = useState();
  const [isTrackOrderModalVisible, setIsTrackOrderModalVisible] = useState(false);
  const [trackOrderLogs, setTrackOrderLogs] = useState([]);
  const [filters, setFilters] = useState({
    orderId: "",
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);
  const [totalElements, setTotalElements] = useState(0);

  const API_URL = process.env.REACT_APP_API_URL;
  const hospitalId = localStorage.getItem("hospitalid") || "";
  useEffect(() => {
    fetchOrders();
  }, [filters]);

  async function fetchOrders(page = currentPage) {
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const clinicId = localStorage.getItem("clinicId");
    try {
      const resp = await axios.get(
        `${API_URL}orders?orderType=surgery&clinicId=${clinicId}` +
          `&fromDate=${filters.fromDate}` +
          `&toDate=${filters.toDate}` +
          (filters.orderId ? `&id=${filters.orderId}` : "") +
          `&page=${page - 1}&size=${pageSize}`,
        {
          headers: {
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
            tenantId: tenantId,
          },
        }
      );
      setOrders(resp.data.records || []);
      setFilteredOrders(resp.data.records || []);
      setTotalElements(resp.data.totalElements || 0);
      setCurrentPage(page);
    } catch (err) {
      console.error("Fetch error:", err.response || err);
    }
  }

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSearch = () => {
    fetchOrders(1);
  };

  const handleReset = () => {
    const defaultFilters = {
      orderId: "",
      fromDate: format(new Date(), "yyyy-MM-dd"),
      toDate: format(new Date(), "yyyy-MM-dd"),
    };
    setFilters(defaultFilters);
    fetchOrders(1);
  };

  const handlePageChange = (page) => {
    fetchOrders(page);
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setIsModalVisible(true);
  };

  const handleEnquiry = async (order) => {
    console.log(order, order.patientId, "order");
    const token = localStorage.getItem("auth_token");
    const tenantId = localStorage.getItem("tenantId");
    const response = await axios.get(
      `${API_URL}patient/search?patientId=${order.patientId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          tenantId: tenantId,
        },
      }
    );

    const Patientdata = response?.data.data[0];
    const payload = {
      patientDetails: {
        patientId: order.patientId,
        medicaseId: "",
        patientName: `${Patientdata.firstName} ${Patientdata.lastName}`,
        dob: Patientdata.dob,
        gender: Patientdata.gender,
        mobileNumber: Patientdata.mobileNumber,
        email: "",
        escallationNumber: "",
        address: Patientdata.address || order.address || "",
        pincode: Patientdata.pinCode,
      },
      serviceDetailsMessage: "",
      tickeType: "SURGERY",
      ticketSource: "HOSPITAL360",
      hospitalId: hospitalId,
    };
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/add-ticket-d2c`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const Data = await res.json();
      if (Data.status == 200) {
        toast.success(Data.message);

        // Make the second API call with the ticket ID from the first response
        const ticketId = Data.data.id;
        const orderId = order.id;

        try {
          const secondRes = await fetch(
            `${API_URL}createenquiry/order?orderId=${orderId}`,
            {
              method: "PUT",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                tenantId: tenantId,
              },
              body: JSON.stringify({
                ticketId: ticketId,
                ticketStatus: "INPROGRESS",
              }),
            }
          );

          if (secondRes.ok) {
            // Handle plain text response
            const responseText = await secondRes.text();
            toast.success(responseText || "Enquiry ticket added successfully");
            console.log("Second API response:", responseText);
            
            // Reload the page to show updated status
            window.location.reload();
          } else {
            // Try to get error message from response
            let errorMessage =
              "Failed to create enquiry. Please try again later.";
            try {
              const errorData = await secondRes.json();
              errorMessage = errorData.message || errorMessage;
            } catch (e) {
              // If JSON parsing fails, try text
              try {
                const errorText = await secondRes.text();
                errorMessage = errorText || errorMessage;
              } catch (textError) {
                console.error("Could not parse error response:", textError);
              }
            }
            toast.error(errorMessage);
            console.error("Second API error:", errorMessage);
          }
        } catch (secondError) {
          toast.error("Failed to create enquiry. Please try again later.");
        }
      } else {
        toast.error("Failed to register ticket. Please try again later.");
      }
      console.log(Data, "dxfghj");
    } catch (error) {
      console.error("Failed to register ticket", error);
    }
  };

  const handleTrackEnquiry = async (order) => {
    const token = localStorage.getItem("auth_token");

    // Get the first ticket ID from the enquiryTickets array
    const ticketId = order.enquiryTickets[0].ticketId;

    console.log("Calling API with ticketId:", ticketId);
    console.log("Order enquiryTickets:", order.enquiryTickets);

    // Call the API to get ticket details
    const response = await fetch(
      `${process.env.REACT_APP_API_COMMAND_CENTER_URL}patient/ticket/${ticketId}`,
      {
        method: "GET",
        headers: {
          accept: "application/json",

        },
      }
    );

    console.log("API Response status:", response.status);
    console.log("API Response:", response);

    const ticketData = await response.json();
    setTicketdata(ticketData.data)
    console.log("Ticket details:", ticketData);
    setIsModalVisible2(true);
  };

  const API_SURGERY_STATUS_URL = process.env.REACT_APP_SURGERY_STATUS;
  const handleTrackOrder = async (order) => {
    console.log(order?.surgeryEnquiry[0]?.surgeryEnquiryId, "orderjhbk");
    const enquiryId = order?.surgeryEnquiry[0]?.surgeryEnquiryId;
    try {
      const response = await axios.post(
        `${API_SURGERY_STATUS_URL}statusLog/getEnquiryStatusLogList`,
        { enquiryId: enquiryId },
        { headers: { "Content-Type": "application/json" } }
      );
      console.log("Track Order response:", response?.data);
      const logs = response?.data?.successList || [];
      // Custom priority: Ensure specific statuses come first in a defined order
      const priorityOrderMap = {
        "Assign CE": 0,
        "Procedure Confirmed": 1,
      };
      const sortedLogs = [...logs].sort((a, b) => {
        const pa = priorityOrderMap[a.statusName] ?? 999;
        const pb = priorityOrderMap[b.statusName] ?? 999;
        if (pa !== pb) return pa - pb; // priority first
        // Then sort by date (newest first)
        const aDate = new Date(a.modifiedDate);
        const bDate = new Date(b.modifiedDate);
        return bDate - aDate;
      });
      setTrackOrderLogs(sortedLogs);
      setIsTrackOrderModalVisible(true);
      // if (!sortedLogs.length) {
      //   toast.info("No tracking updates found");
      // }
    } catch (error) {
      console.error("Track Order error:", error?.response || error);
      toast.error("Failed to track order");
    }
  };

  const SurgeryCard = ({ order }) => {
    const surgeryDetails = order.surgeryEnquiry && order.surgeryEnquiry.length > 0 
      ? order.surgeryEnquiry[0] 
      : null;

    return (
      <div className="relative bg-white rounded-lg p-4 shadow-sm border w-full">
        <div className="flex items-start gap-4">
          <img
            src={surgeryicon}
            alt="Surgery Icon"
            className="w-10 h-10 mt-1"
          />
          <div className="flex-1">
            <p className="text-md font-semibold text-[#003F6B] mb-1">
              <span className="text-green-600">{order?.patientName}</span>
            </p>
            <p className="text-sm text-gray-700 mt-1 mb-1">Id: {order.id}</p>
            {order.createdDate && (
              <p className="text-sm text-gray-700 mb-1">
                Placed On: {order.createdDate?.split("T")[0]}
              </p>
            )}
            {surgeryDetails?.procedureName && (
              <p className="text-sm text-gray-700 mb-1">
                Procedure: {surgeryDetails.procedureName}
              </p>
            )}
            {surgeryDetails?.hospitalName && (
              <p className="text-sm text-gray-700 mb-1">
                Hospital: {surgeryDetails.hospitalName}
              </p>
            )}
          </div>
          {(!order.enquiryTickets || order.enquiryTickets.length === 0) && (
            <img
              className="cursor-pointer w-8 h-8 "
              title="Customer Support"
              src={customericon}
              alt="Customer"
              onClick={() => handleEnquiry(order)}
            />
          )}
        </div>

        <div className="mt-4 flex justify-center gap-2">
          <button
            className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
            onClick={() => handleViewDetails(order)}
          >
            View Details
          </button>
          <button
            className="border border-[#003F6B] hover:bg-[#003F6B] hover:text-white text-[#003F6B] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
      
            onClick={() => handleTrackOrder(order)}
          >
            Track Order
          </button>
          {order.enquiryTickets && order.enquiryTickets.length > 0 && (
            <button
              className="border border-[#00B77E] hover:bg-[#00B77E] hover:text-white text-[#00B77E] px-3 py-1.5 rounded text-xs font-medium transition-colors duration-200"
              onClick={() => handleTrackEnquiry(order)}
            >
              Track Enquiry
            </button>
          )}
        </div>
      </div>
    );
  };

  return (
    <OurLayouts>
      <div className="min-h-screen p-4 bg-[#f1f8f7] rounded-lg">
        <div className="max-w-6xl mx-auto">
          <div className="bg-[#F0F9FB] min-h-screen rounded-lg">
            <div className="flex items-center justify-between mb-3">
              <h2 className="text-xl font-semibold text-[#003F6B]">
                Surgery Enquiries
              </h2>
            </div>

            {/* Filter Form */}
            <div className="rounded-lg shadow-sm mb-6">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Order ID
                  </label>
                  <input
                    type="text"
                    name="orderId"
                    value={filters.orderId}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                    placeholder="Enter Order ID"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    name="fromDate"
                    value={filters.fromDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    To Date
                  </label>
                  <input
                    type="date"
                    name="toDate"
                    value={filters.toDate}
                    onChange={handleFilterChange}
                    className="w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div className="flex items-end space-x-2">
                  <button
                    onClick={handleSearch}
                    className="bg-[#003F6B] text-white px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Search
                  </button>
                  <button
                    onClick={handleReset}
                    className="border border-[#003F6B] text-[#003F6B] px-4 py-2 rounded-md text-sm font-medium"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>

            {filteredOrders.length > 0 ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                  {filteredOrders.map((order, index) => (
                    <SurgeryCard key={index} order={order} />
                  ))}
                </div>

                {/* Pagination */}
                <div className="flex justify-center mt-6">
                  <Pagination
                    current={currentPage}
                    pageSize={pageSize}
                    total={totalElements}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
              </>
            ) : (
              <div className="flex flex-col items-center justify-center h-full text-gray-500">
                <img src={nodata} alt="No Data" className="w-64 h-64 mb-4" />
                <div className="text-center text-gray-600">
                  No orders found for the selected filters.
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalVisible && selectedOrder && (
        <OrderDetailsModal
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          subtitle="Surgery Order Details"
          patientName={selectedOrder.patientName}
          status={selectedOrder.enquiryTickets?.[0]?.ticketStatus}
          address={selectedOrder.address}
          infoFields={[
            { label: "Order ID", value: selectedOrder.id, mono: true },
            {
              label: "Placed On",
              value: selectedOrder.createdDate?.split("T")[0],
            },
            { label: "Mobile No", value: selectedOrder.patientMobileNo },
          ]}
        >
          <SurgeryEnquiryCards surgeryEnquiry={selectedOrder.surgeryEnquiry} />
        </OrderDetailsModal>
      )}

      {isModalVisible2 && (
        <TrackEnquiry 
          isModalVisible2={isModalVisible2} 
          setIsModalVisible2={setIsModalVisible2} 
          ticketdata={ticketdata}
        />
      )}

      {isTrackOrderModalVisible && (
        <Modal
          title="Order Tracking"
          open={isTrackOrderModalVisible}
          onCancel={() => setIsTrackOrderModalVisible(false)}
          footer={null}
          width={700}
        >
          {trackOrderLogs && trackOrderLogs.length > 0 ? (
            <div>

              <div className="relative">
                <div className="absolute left-3 top-0 bottom-0 border-l-2 border-gray-200" />
                <div className="space-y-4">
                  {trackOrderLogs.map((log, index) => {
                    const statusChipColor = log.reasonForReject
                      ? "bg-red-100 text-red-700 border-red-200"
                      : log.statusType === "C"
                      ? "bg-green-100 text-green-700 border-green-200"
                      : log.statusType === "B"
                      ? "bg-blue-100 text-blue-700 border-blue-200"
                      : "bg-amber-100 text-amber-700 border-amber-200";
                    return (
                      <div key={log.id || index} className="relative pl-8">
                        <span className="absolute left-0 top-1.5 w-3 h-3 rounded-full bg-[#003F6B] border-2 border-white shadow" />
                        <div className="bg-white rounded-md border p-3">
                          <div className="flex items-center justify-between">
                            <div className={`text-xs px-2 py-0.5 rounded-full border ${statusChipColor}`}>
                              {log.statusName || "Status"}
                            </div>
                            {log.modifiedDate && (
                              <div className="text-xs text-gray-600">
                                {(() => {
                                  try {
                                    return format(new Date(log.modifiedDate.replace(" ", "T")), "dd/MM/yyyy HH:mm");
                                  } catch (e) {
                                    return log.modifiedDate;
                                  }
                                })()}
                              </div>
                            )}
                          </div>
                          <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-2 text-xs text-gray-700">
                            {log.userName && (
                              <div><span className="text-gray-500">Updated By:</span> {log.userName}</div>
                            )}
                           
                          </div>
                          {log.reasonForReject && (
                            <div className="mt-2 text-xs text-red-600">
                              Rejection Reason: {log.reasonForReject}
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center text-gray-600">No tracking data available.</div>
          )}
        </Modal>
      )}
    </OurLayouts>
  );
};

export default ClinicSurgeryDetails;
